/** Mirrors `OKIS.Domain.Shared.Classifiers.ClsfLegislationType`, stored as an `int` column on `clsf_legislation`. */
export enum ClsfLegislationType {
	Law = 1,
	Code = 2,
	GovernmentResolution = 3,
	Order = 4,
	EuRegulation = 5,
	EuDirective = 6,
	EuDecision = 7,
	Other = 8,
}
